import _timerange from "./_timerange";
import parser from "../parser";

const separator = parser.word(/\s*--\s*/);

const star = parser.word("*").map(function() {
    return {
        "start": -Infinity,
        "end": Infinity
    };
});

export default parser.union(
    parser.union(
        parser.sequence(star, separator, _timerange),
        parser.sequence(_timerange, separator, star),
        parser.sequence(_timerange, separator, _timerange)
    ).pick(0, 2).map(function(match) {
        return {
            "start": match[0].start,
            "end": match[1].end
        };
    }),
    _timerange
).map(function(range) {
    return {
        "start": range.start,
        "end": range.end
    };
});



// WEBPACK FOOTER //
// ./src/abusesa-js/formats/timerange.js